'use strict';

var index = require('../../../../../index-B_8xeRkv.js');

"use strict";
const pluginVersion = "12.4.1";
const defaultOptions = {
  displayMode: index.BarGaugeDisplayMode.Gradient,
  maxVizHeight: 300,
  minVizHeight: 16,
  minVizWidth: 8,
  namePlacement: index.BarGaugeNamePlacement.Auto,
  showUnfilled: true,
  sizing: index.BarGaugeSizing.Auto,
  valueMode: index.BarGaugeValueMode.Color
};

exports.defaultOptions = defaultOptions;
exports.pluginVersion = pluginVersion;
